module.exports = __webpack_public_path__ + "img/39.f607968c.jpg";